export default __webpack_public_path__ + "static/media/bleedingpuncture2.d6fe1e59.png";